// --prussian-blue: hsla(196, 94%, 13%, 1);
// --pacific-blue: hsla(192, 59%, 51%, 1);
// --blue-ncs: hsla(195, 100%, 38%, 1);
// --prussian-blue-2: hsla(203, 49%, 18%, 1);
// --blue-sapphire: hsla(194, 95%, 29%, 1);

export const lightMode = {
	background: "#fff",
	text: "hsla(196, 94%, 13%, 1)",
	activebackground: "rgb(45, 51, 79)",
	activeEventBackground: "rgb(45, 51, 79)",
	activeText: "#fff",
	calenderHover: "hsla(195, 100%, 38%, 1)",
};

export const darkMode = {
	background: "#0E141B",
	text: "rgb(199, 192, 224)",
	activebackground: "rgb(89, 116, 189)",
	activeEventBackground: "rgb(141, 148, 199)",
	activeText: "rgb(191, 207, 247)",
	calenderHover: "rgb(89, 116, 189)",
};
